module.exports = __webpack_public_path__ + "static/media/Processsing.645b106d.svg";